import { OrgusMark } from '@orgus/ui';

/**
 * The Orgus mark (the Keep) in the accent colour. Decorative: every caller writes the product
 * name beside it. From 20 to 28 px it draws the 24-unit optical cut, which is pixel-exact at 24.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return <OrgusMark size={size} decorative />;
}
